// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wf_a bht_b bht_we"};